import { ActionTree } from 'vuex';
import { ITagState } from './tag.types';
import { ETagAction, ETagMutation } from './tag.constants';
import { RootState } from '@/store/store';
import { ITag } from '@lib-shared/types/Tag';
import { translate } from '@/helpers/translation.helper';
import { alertNamespace, EAlertAction } from '@/alert/store/alert.constants';
import { TagService } from '@/api/tags/services/tag.service';

export const actions: ActionTree<ITagState, RootState> = {
  async [ETagAction.Create]({ dispatch, commit }, name: string) {
    commit(ETagMutation.SetLoading, true);
    try {
      const createdTag: ITag = await TagService.create(name);
      dispatch(ETagAction.CreateSuccess, createdTag);
    } catch (error) {
      dispatch(ETagAction.CreateFailed, error);
    }
    commit(ETagMutation.SetLoading, false);
  },
  [ETagAction.CreateSuccess]({ commit }, createdTag: ITag) {
    commit(ETagMutation.AddTag, createdTag);
    commit(ETagMutation.SetLoading, false);
  },
  [ETagAction.CreateFailed]({ dispatch, commit }) {
    commit(ETagMutation.SetLoading, false);
    dispatch(
      `${alertNamespace}/${EAlertAction.ShowDanger}`,
      translate('Could-not-create-new-tag'),
      {
        root: true,
      }
    );
  },

  async [ETagAction.Load]({ dispatch, commit }) {
    commit(ETagMutation.SetLoaded, false);
    commit(ETagMutation.SetLoading, true);
    try {
      const tags: ITag[] = await TagService.load();
      dispatch(ETagAction.LoadSuccess, tags);
    } catch (error) {
      dispatch(ETagAction.LoadFailed);
    }
  },
  [ETagAction.LoadSuccess]({ commit }, tags: ITag[]) {
    commit(ETagMutation.SetTags, tags);
    commit(ETagMutation.SetLoaded, true);
    commit(ETagMutation.SetLoading, false);
  },
  [ETagAction.LoadFailed]({ dispatch, commit }) {
    commit(ETagMutation.SetLoaded, false);
    commit(ETagMutation.SetLoading, false);
    dispatch(`${alertNamespace}/${EAlertAction.ShowDanger}`, translate('could-not-load-tags'), {
      root: true,
    });
  },
};
